
import { alertActions, languageActions } from 'actions';
import { accountConstants, permissionConstants, accountTypesConstants } from '../constants';

import { accountService, permissionService } from 'services';
import { userStorage } from 'helpers';
import { gisRoutes } from '../routes/routes';
import { global } from 'config';
import { store, history } from 'helpers';
import * as token from 'helpers/token';

export const accountActions = {
  login,
  logout,
  register,

  getAccountType,
  getAllAccountTypes,
  getAllCustomerAccountTypes,
  getProfile,
  getAllAccounts,
  getAccount,

  getAllByCustomer,

  checkToken,

  addInterimAccount,
  addCustomerAccount,

  updateProfile,
  updateAccount,
  updatePassword,
  resetPassword,
  forgotPassword,

  deleteAccount,
  deleteOwnAccount
};

function login(email, password) {
  return dispatch => {
    dispatch(request({ email }));

    accountService.login(email, password)
      .then(response => {
        userStorage.setUser(response.data);
        languageActions.update(response.data.account.userprofile.language);
        const account_type = token.loggedAccountType();
        permissionService.getLoggedAccountPermissions()
          .then(data => {
            dispatch(success(response));
            userStorage.setPermissions(data.data.permissions);
            dispatch(loadpermissions(token.decodeToken(data.data.permissions)));
            const loggedtype = accountTypesConstants[token.loggedAccountType()];
            // Store user details and jwt token in local storage to keep user logged in between page refreshes
            if (loggedtype) {
              if (token.loggedAccountType() == 400) history.push(gisRoutes.visitor.dashboard);
              else history.push(gisRoutes.dashboard[loggedtype]);
            } else {
              history.push(global.logout);
            }
            // window.location.reload(false);
          }).catch(error => {
            dispatch(failure(error));
            dispatch(alertActions.error(error.data || error.message));
            history.push(global.logout);
          });
      }).catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
        history.push(global.logout);
      });
  };

  function request(account) { return { type: accountConstants.LOGIN_REQUEST, account } }
  function success(account) { return { type: accountConstants.LOGIN_SUCCESS, account } }
  function loadpermissions(data) { return { type: permissionConstants.GET_LOGGED_SUCCESS, data } }
  function failure(error) { return { type: accountConstants.LOGIN_FAILURE, error } }
}

function register(registration) {
  return dispatch => {
    dispatch(request(registration));

    accountService.register(registration)
      .then(response => {
        setTimeout(function () { dispatch(alertActions.success(response.message)) }, 1000);
        history.push('/');
      }).catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      });
  };

  function request(user) { return { type: accountConstants.LOGIN_REQUEST, user } }
  function success() { return { type: accountConstants.REGISTER } }
  function failure(error) { return { type: accountConstants.LOGIN_FAILURE, error } }
}

function logout() {
  return dispatch => {
    if (accountService.isLoginActive()) {
      accountService.logout();

      dispatch(success(false));
      setTimeout(function () { dispatch(alertActions.success('Logout successfully')) }, 1000);
      history.push('/');
    }

    dispatch(success(true));

    function success(load) {
      if (load)
        return { type: accountConstants.LOGIN_LOAD };
      else
        return { type: accountConstants.LOGOUT };
    }
  };
}

function getProfile() {
  return dispatch => {

    accountService.getProfile()
      .then(
        data => dispatch(success(data)),
        error => dispatch(failure(error))
      );
  };

  function request() { return { type: accountConstants.GET_PROFILE_REQUEST } }
  function success(userprofile) { return { type: accountConstants.GET_PROFILE_SUCCESS, userprofile } }
  function failure(error) { return { type: accountConstants.GET_PROFILE_FAILURE, error } }
}


function getAccountType(account_type_id) {
  return dispatch => {
    dispatch(request());

    accountService.getAccountType(account_type_id)
      .then(
        data => dispatch(success(data.account_type)),
        error => dispatch(failure(error))
      );
  };

  function request() { return { type: accountConstants.GET_REQUEST } }
  function success(account_type) { return { type: accountConstants.GET_TYPE_SUCCESS, account_type } }
  function failure(error) { return { type: accountConstants.GET_TYPE_FAILURE, error } }
}

function getAllAccounts(limit = global.LIMIT, page = global.PAGE, filters) {
  return dispatch => {
    dispatch(request());

    accountService.getAllAccounts(limit, page, filters)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: accountConstants.GET_ALL_REQUEST } }
  function success(accounts) { return { type: accountConstants.GET_ALL_SUCCESS, accounts } }
  function failure(error) { return { type: accountConstants.GET_ALL_FAILURE, error } }
}

function getAllAccountTypes(limit = global.LIMIT, page = global.PAGE, filters) {
  return dispatch => {
    dispatch(request());

    accountService.getAllAccountTypes(limit, page, filters)
      .then(
        data => dispatch(success(data)),
        error => dispatch(failure(error))
      );
  };

  function request() { return { type: accountConstants.GET_ALL_TYPE_REQUEST } }
  function success(account_types) { return { type: accountConstants.GET_ALL_TYPE_SUCCESS, account_types } }
  function failure(error) { return { type: accountConstants.GET_ALL_TYPE_FAILURE, error } }
}

function getAllCustomerAccountTypes
  (limit = global.LIMIT, page = global.PAGE) {
  return dispatch => {
    dispatch(request());

    accountService.getAllCustomerAccountTypes(limit, page)
      .then(
        data => dispatch(success(data)),
        error => dispatch(failure(error))
      );
  };

  function request() { return { type: accountConstants.GET_ALL_TYPE_REQUEST } }
  function success(account_types) { return { type: accountConstants.GET_ALL_TYPE_SUCCESS, account_types } }
  function failure(error) { return { type: accountConstants.GET_ALL_TYPE_FAILURE, error } }
}


function getAccount(account_id) {
  return dispatch => {
    dispatch(request());

    accountService.getAccount(account_id)
      .then(
        data => dispatch(success(data)),
        error => dispatch(failure(error))
      );
  };

  function request() { return { type: accountConstants.GET_REQUEST } }
  function success(account) { return { type: accountConstants.GET_SUCCESS, account } }
  function failure(error) { return { type: accountConstants.GET_FAILURE, error } }
}


function getAllByCustomer(limit = global.LIMIT, page = global.PAGE, filters) {
  return dispatch => {
    dispatch(request());

    accountService.getAllByCustomer(limit, page, filters)
      .then(
        data => dispatch(success(data)),
        error => dispatch(alertActions.error(error.data))
      );
  };

  function request() { return { type: accountConstants.GET_BY_CUSTOMER_ALL_REQUEST } }
  function success(accounts) { return { type: accountConstants.GET_BY_CUSTOMER_ALL_SUCCESS, accounts } }
  function failure(error) { return { type: accountConstants.GET_BY_CUSTOMER_ALL_FAILURE, error } }
}

function checkToken(token) {
  return dispatch => {

    accountService.checkToken(token)
      .catch(
        error => {
          history.push(global.login || '/');
          dispatch(alertActions.error(error.message || error.data));
        }
      );
  };
}

function addInterimAccount(newValues) {
  return dispatch => {
    dispatch(request(newValues));

    accountService.addInterimAccount(newValues)
      .then(
        data => {
          dispatch(success(data.data));
          dispatch(alertActions.success(data.message));
          history.push(gisRoutes.account.account.list);
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        });
  };

  function request() { return { type: accountConstants.ADD_INTERIM_ACCOUNT_REQUEST } }
  function success(account) { return { type: accountConstants.ADD_INTERIM_ACCOUNT_SUCCESS, account } }
  function failure(error) { return { type: accountConstants.ADD_INTERIM_ACCOUNT_FAILURE, error } }
}

function addCustomerAccount(newValues) {
  return dispatch => {
    dispatch(request(newValues));

    accountService.addCustomerAccount(newValues)
      .then(
        data => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          history.push(gisRoutes.account.account.list);
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        });
  };

  function request() { return { type: accountConstants.ADD_CUSTOMER_ACCOUNT_REQUEST } }
  function success(account) { return { type: accountConstants.ADD_CUSTOMER_ACCOUNT_SUCCESS, account } }
  function failure(error) { return { type: accountConstants.ADD_CUSTOMER_ACCOUNT_FAILURE, error } }
}



function updateProfile(updatedValues) {
  return dispatch => {
    dispatch(request(updatedValues));

    accountService.updateProfile(updatedValues)
      .then(
        data => {
          if (updatedValues.email !== '' && updatedValues.email !== token.loggedUser().email) {
            dispatch(alertActions.success('Profile updated successfully. You will be log out. Please log with the new email.'));
            setTimeout(function () { history.push(global.logout) }, 2000);
          } else {
            dispatch(success(data.userprofile));
            const keyList = ['customer_id', 'firstname', 'lastname', 'language'];
            const updatedLogged = {}
            keyList.map(key => updatedLogged[key] = updatedValues[key]);
            userStorage.updateProfile({ userprofile: updatedLogged });
            languageActions.update(updatedValues.language);
            dispatch(alertActions.success(data.message));
            setTimeout(function () { window.location.reload() }, 3000);
          }
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        });
  };

  function request() { return { type: accountConstants.UPDATE_PROFILE_REQUEST } }
  function success(userprofile) { return { type: accountConstants.UPDATE_PROFILE_SUCCESS, userprofile } }
  function failure(error) { return { type: accountConstants.UPDATE_PROFILE_FAILURE, error } }
}

function updateAccount(account_id, updatedValues) {
  return dispatch => {
    dispatch(request(updatedValues));

    accountService.updateAccount(account_id, updatedValues)
      .then(
        data => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          setTimeout(function () { window.location.reload() }, 1000);
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        });
  };

  function request() { return { type: accountConstants.UPDATE_REQUEST } }
  function success(account) { return { type: accountConstants.UPDATE_SUCCESS, account } }
  function failure(error) { return { type: accountConstants.UPDATE_FAILURE, error } }
}

function updatePassword(updatedValues) {
  return dispatch => {
    dispatch(request(updatedValues));

    accountService.updatePassword(updatedValues)
      .then(
        data => {
          dispatch(alertActions.success(data.message));
          const loggedtype = accountTypesConstants[token.loggedAccountType()];
          history.push(gisRoutes.dashboard[loggedtype]);
        },
        error => {
          dispatch(failure(error.data));
          dispatch(alertActions.error(error));
        });
  };

  function request() { return { type: accountConstants.RESET_PASSWORD_REQUEST } }
  function success() { return { type: accountConstants.RESET_PASSWORD_SUCCESS } }
  function failure(error) { return { type: accountConstants.RESET_PASSWORD_ERROR, error } }
}


function resetPassword(token, updatedValues) {
  return dispatch => {
    dispatch(request(token, updatedValues));

    accountService.resetPassword(token, updatedValues)
      .then(
        data => {
          history.push(global.login || '/');
          dispatch(alertActions.success(data.message));
        },
        error => {
          dispatch(failure(error.data));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: accountConstants.RESET_PASSWORD_REQUEST } }
  function success() { return { type: accountConstants.RESET_PASSWORD_SUCCESS } }
  function failure(error) { return { type: accountConstants.RESET_PASSWORD_ERROR, error } }
}

function forgotPassword(email) {
  return dispatch => {

    accountService.forgotPassword(email)
      .then(
        data => {
          history.push(global.login || '/');
          dispatch(alertActions.success(data.message));
        }, error => {
          history.push(global.login || '/');
          dispatch(alertActions.error(error.data || error.message));
        });
  };
}

function deleteAccount(account_id) {
  return dispatch => {
    dispatch(request());

    accountService.deleteAccount(account_id)
      .then(
        data => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          setTimeout(function () { window.location.reload() }, 2000);
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: accountConstants.DELETE_REQUEST } }
  function success() { return { type: accountConstants.DELETE_SUCCESS } }
  function failure(error) { return { type: accountConstants.DELETE_FAILURE, error } }
}


function deleteOwnAccount(password) {
  return dispatch => {
    dispatch(request());

    accountService.deleteOwnAccount(password)
      .then(
        data => {
          userStorage.removeUser();
          setTimeout(function () { dispatch(alertActions.success(data.message)) }, 1000);
          history.push('/');
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: accountConstants.DELETE_REQUEST } }
  function success() { return { type: accountConstants.DELETE_SUCCESS } }
  function failure(error) { return { type: accountConstants.DELETE_FAILURE, error } }
}
